import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { DataGrid, IGridColDef, Grid, IconButton, Stack, Button, Checkbox } from 'src/components';
import Card from 'src/components/Card';
import CardContent from 'src/components/CardContent';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import { translate } from 'src/i18n/tHelper';
import VwKurumbonustanimtestveriDTO from 'src/models/KurumBonusTanim/VwKurumbonustanimtestveriDTO';
import IptalNedenSecim from 'src/parts/Genel/IptalNedenSecim';
import RecordInfo from 'src/parts/Genel/record.info';
import api from 'src/services/core/api';
import { useKurumBonusTanimTestVeriListesiQuery, useKurumBonusTanimTestVeriSilMutation } from 'src/services/KurumBonusTanimlari/KurumBonusTanimlariApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { kurumBonusTanimlariTestVeVeriyeGoreSlice } from 'src/store/Slices/KurumBonusTanimlari/KurumBonusTanimlariTestVeVeriyeGoreSlice';

const translatePath = "pages|kurumBonusTanimlari";
const KurumBonusTanimlariTestVeVeriyeGoreListe = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlariTestVeVeriyeGore);
    const kurumBonusTanimlariTestBazliState = useAppSelector(s => s.kurumBonusTanimlariTestBazli);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [iptal, setIptal] = useState<boolean>(false);

    const query = useKurumBonusTanimTestVeriListesiQuery({ kurumBonusTanimDetayId: kurumBonusTanimlariTestBazliState.activeRow?.id, iptalGosterme: state.iptalGosterme }, { skip: kurumBonusTanimlariTestBazliState.activeRow?.id > 0 ? false : true, refetchOnMountOrArgChange: true });
    const [iptalEt, iptalEtState] = useKurumBonusTanimTestVeriSilMutation();

    const handlerEdit = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumbonustanimtestveriDTO): void => {
        dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setActiveRow(row));
        dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setOpen(true));
    }
    const handlerDelete = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumbonustanimtestveriDTO): void => {
        dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setActiveRow(row));
        setIptal(true);
    }

    const columns: IGridColDef<VwKurumbonustanimtestveriDTO>[] = [
        {
            field: "kurumAdi",
            headerName: translate(translatePath, "Kurum Adı"),
            flex: 1,
            minWidth: 200,
        },
        {
            field: "tanimDetayIslemAdi",
            headerName: translate(translatePath, "Tanım İşlem Adı"),
            flex: 1,
            minWidth: 200,
        },
        {
            field: "veriAralikBaslangic",
            headerName: translate(translatePath, "Veri Aralık Başlangıç"),
            width: 100,
            type: "number",
        },
        {
            field: "veriAralikBitis",
            headerName: translate(translatePath, "Veri Aralık Bitiş"),
            width: 100,
            type: "number",
        },
        {
            field: "testDetaybilgiIslemAdi",
            headerName: translate(translatePath, "Test Detay İşlem Adı"),
            flex: 1,
            minWidth: 200,
        },
        {
            field: "aciklama",
            headerName: translate(translatePath, "Test Detay Açıklama"),
            flex: 1,
            minWidth: 200,
        },
        {
            field: "sira",
            headerName: translate(translatePath, "Test Detay Sıra"),
            width: 75,
            type: "number",
        },
        {
            field: "testDetaybilgiaktif",
            headerName: translate(translatePath, "Test Detay Aktif"),
            width: 75,
            type: "boolean",
            valueGetter: (params) => { return params.row?.testDetaybilgiaktif === "E"; }
        },
        {
            field: "lishesap",
            headerName: translate(translatePath, "Lis Hesap"),
            width: 75,
            type: "boolean",
            valueGetter: (params) => { return params.row?.lishesap === "E"; }
        },
        {
            field: "minimumdeger",
            headerName: translate(translatePath, "Test Detay Minimum Değer"),
            width: 150,
            type: "number",
        },
        {
            field: "maksimumdeger",
            headerName: translate(translatePath, "Test Detay Maksimum Değer"),
            width: 150,
            type: "number",
        },
        {
            field: "zorunlu",
            headerName: translate(translatePath, "Zorunlu"),
            width: 75,
            type: "boolean",
            valueGetter: (params) => { return params.row?.zorunlu === "E"; }
        },
        {
            field: "action",
            headerName: translate(translatePath, "İşlemler"),
            width: 110,
            renderCell: (params) => {
                return (
                    <Stack direction="row">
                        {!params.row?.iptalTarihi && (
                            <>
                                <IconButton customType="edit" onClick={(e) => { handlerEdit(e, params.row); }} />
                                <IconButton customType="delete" loading={params.row?.id === iptalEtState.originalArgs?.id && iptalEtState.isLoading} onClick={(e) => { handlerDelete(e, params.row); }} />
                            </>
                        )}
                        <RecordInfo
                            id={params.row.id}
                            eklemeTarihi={params.row.eklemeTarih}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            guncellemeTarihi={params.row.guncellemeTarihi}
                            guncelleyenKullanici={params.row.guncelleyenKullanici}
                            iptalKullanici={params.row.iptalKullanici}
                            iptalTarihi={params.row.iptalTarihi}
                            iptalNedenGrupId={ParametreGrupEnum.TanimIptalNedenleri}
                            iptalNedenId={params.row.iptalNedenId}
                        />
                    </Stack>
                );
            },
        },
    ];

    const filterData = (data: Array<VwKurumbonustanimtestveriDTO>): Array<VwKurumbonustanimtestveriDTO> => {
        if (!Array.isArray(data)) return [];
        return data;
    };

    const handlerSearch = (event: React.MouseEvent<HTMLButtonElement>): void => {
        dispatch(api.util.invalidateTags(["KurumBonusTanimlariDetayTestVeri"]));
    }
    const handlerAdd = (event: React.MouseEvent<HTMLButtonElement>): void => {
        if (kurumBonusTanimlariTestBazliState.activeRow?.id <= 0) return;
        dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setActiveRow({ ...new VwKurumbonustanimtestveriDTO(), fkBonustanimdetayId: kurumBonusTanimlariTestBazliState.activeRow?.id }));
        dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setOpen(true));
    }
    const handlerBack = (event: React.MouseEvent<HTMLButtonElement>): void => {
        navigate(-1);
    }

    return (
        <>
            <Card>
                <CardContent>
                    <DataGrid
                        sx={{ height: "70vh" }}
                        pinnedColumns={{ right: ["action"] }}
                        backButton={<Button customType="back" onClick={handlerBack} />}
                        searchButton={<Button customType="search" loading={query.isFetching} onClick={handlerSearch} />}
                        addButton={<Button customType="add" onClick={handlerAdd} />}
                        loading={query.isFetching}
                        rows={filterData(query.data)}
                        columns={columns}
                        addHeaderColumn={
                            <Stack direction="row">
                                <Checkbox
                                    label={translate(translatePath, "İptalleri Göster")}
                                    checked={state.iptalGosterme === "E"}
                                    onChange={(e, checked) => { dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setIptalGosterme(checked ? "E" : "H")); }}
                                />
                            </Stack>
                        }
                    />
                </CardContent>
            </Card>
            <IptalNedenSecim
                title={translate(translatePath, "Kurum Bonus Tanımı Test Bazlı İptal")}
                parameterType={ParametreGrupEnum.TanimIptalNedenleri}
                loading={iptalEtState.isLoading}
                open={iptal}
                onClosed={() => { setIptal(false); }}
                onSelected={async (iptalNedenId, aciklama, iptalValue) => {
                    if (!iptalEtState.isLoading)
                        await iptalEt({ ...state.activeRow, iptalNedenId: iptalNedenId, iptalAciklama: aciklama }).unwrap().then(() => { }).catch(e => e);
                }}
            />
        </>
    );
};

export default KurumBonusTanimlariTestVeVeriyeGoreListe;